<template>
  <div class="c-m-c" id="calendar-content">
    <div class="msg" v-if="status == 'preparing'">
      <spinner></spinner>
    </div>

    <template v-if="showCalendar">
      <full-calendar :ref="`cal${ym}`" :events="events" :config="configs"></full-calendar>
      <div class="event-list">
        <event-list
          :ym="ym"
          :events="events"
          :currentDate="currentDate"
          @eventClick="showEventDetail"
          @cancelDate="cancelDate"
        ></event-list>
      </div>

      <event-detail-dialog
        :event="selectedEvent"
        v-if="detailDialog"
        @close="resetVal"
        @deleteEventSuccess="deleteEventSuccess"
      >
      </event-detail-dialog>
    </template>
  </div>
</template>

<script>
import eventDetailDialog from '../event/EventDetailDialog.vue';
import eventList from '../event/EventList.vue';
import UTILS from '../../utils/utils';
import { getCachedHolidays, loadHolidays } from '../../utils/holidays';

export default {
  components: {
    'event-detail-dialog': eventDetailDialog,
    'event-list': eventList,
  },
  props: {
    inview: { type: Boolean, required: true },
    error: { type: Boolean, required: false },
    data: { type: Object, required: true },
    ym: { type: Number, required: true },
  },
  mounted() {
    this.initialize(this.yyyymm);
  },
  data() {
    const events = this.data.d ? this.toEvents(this.data.d) : [];
    return {
      events,
      currentDate: null,
      lastClick: {
        d: 0,
        t: 0,
      },
      showCalendar: this.inview,
      configs: {
        defaultView: 'month',
        defaultDate: this.$moment(this.ym + '01', 'YYYYMMDD'),
        // Add tooltip when mouse hover event
        eventRender: function(event, element) {
          let eventLayout = $(
            `<div class="calendar-event caption ${
              event.outOfMonth ? (event.uid ? 'cal-out-loop' : 'cal-out') : event.uid ? 'cal-cur-loop' : 'cal-cur'
            }">${event.uid ? '<i class="v-icon mdi mdi-loop"></i>' : ''}${event.title}</div>`
          );
          if (event.pop) {
            eventLayout.popover({
              title: event.title,
              content: event.desc,
              trigger: 'hover',
              placement: 'top',
              container: 'body',
            });
          }
          return eventLayout;
        },
        eventAfterAllRender: function(event, jsEvent, view) {
          // Event click on calendar => show detail modal
          this.$nextTick(function() {
            this.selectCurrent(this.currentDate);
            this.markHolidays();
          });
        }.bind(this),
        eventClick: function(event, jsEvent, view) {
          // Event click on calendar => show detail modal
          this.showEventDetail(event);
        }.bind(this),
        locale: this.$commin.user.lang,
        // config when one day have a lot of events
        eventLimit: 3,
        eventLimitClick: 'popover',
        // disable drag and drop event
        eventStartEditable: false,
        height: 'auto',
      },
      detailDialog: false,
      selectedEvent: null,
    };
  },
  watch: {
    inview(n, o) {
      if (n) this.showCalendar = true;
    },
    yyyymm(n, o) {
      this.initialize(n);
    },
    error(newValue, oldValue) {
      if (newValue) {
        console.error('failed to get data');
        this.errGetData();
      }
    },
    dataEvents(newValue, oldValue) {
      // update events only when changed.
      console.log(`got data for ${this.ym}`);
      this.events = this.toEvents(newValue);
    },
    tabYmTouchEnd(n, o) {
      if (n.moving || n.px > 20 || n.t > 500 || this.ym != this.yyyymm) return;
      var tgt = n.event.target;
      var date = tgt.getAttribute('data-date');
      if (!date) {
        var row = tgt.closest('.fc-week');
        if (!row) return console.log('no row for fc-week.');
        var eCon = tgt.closest('.calendar-event');
        var cCon = tgt.closest('.fc-more-cell');
        if (eCon || cCon) return console.log('skip on event click.');

        if (tgt.tagName != 'TD') tgt = tgt.closest('TD');
        var tgtRect = tgt.getBoundingClientRect();

        var r = row.getElementsByTagName('thead')[0].getElementsByTagName('tr')[0];
        var heads = r.childNodes;
        var date = null;
        for (var h of heads) {
          if (h.getBoundingClientRect().left == tgtRect.left) {
            date = h.getAttribute('data-date');
            break;
          }
        }
        if (!date) {
          return console.warn(`failed to get data-date`);
        }
      }

      // show create event modal with start = selected date
      var l = this.lastClick;
      var t = time();
      console.log(`day click d=${date} t=${t - l.t} ld=${l.d} r=${date == l.d}`);
      var dclick = false;
      if (date == l.d && t - l.t <= 500) {
        dclick = true;
        this.$store.commit('CAL_REGISTER', date);
      }
      if (this.currentDate == date) {
        if (!dclick) {
          var self = this;
          setTimeout(function() {
            if (self.lastClick.t == t) {
              self.currentDate = null;
            }
          }, 500);
        }
      } else {
        this.currentDate = date;
      }
      this.lastClick = {
        d: date,
        t: t,
      };
    },
    currentDate(n, o) {
      this.selectCurrent(n);
    },
  },
  computed: {
    yyyymm() {
      return this.$store.state.tools.yyyymm;
    },
    status() {
      // 'preparing' || 'cache' || 'clientdb' || 'done'
      return this.data.s;
    },
    dataEvents() {
      return this.data.d;
    },
    tabYmTouchEnd() {
      return this.$store.state.tools.tabYmTouchEnd;
    },
  },
  methods: {
    initialize(yyyymm) {
      if (yyyymm == this.ym) {
        this.showCalendar = true;
      } else {
        this.currentDate = null;
      }
      this.selectCurrent(this.currentDate);
    },
    selectCurrent(d) {
      var r = this.$refs[`cal${this.ym}`];
      if (!r) return console.warn(`cal${this.ym} is not there.`);
      this.removeOrgClass();
      if (d) {
        var m = this.$moment(d);
        r.fireMethod('select', m);
        this.$nextTick(function() {
          this.addOrgClass(m);
        });
      } else {
        r.fireMethod('unselect');
      }
    },
    cancelDate() {
      this.currentDate = null;
      this.removeOrgClass();
    },
    addOrgClass(m) {
      var cal = this.$refs[`cal${this.ym}`].$el;
      var ele = cal.querySelector(`td.fc-day[data-date='${m.format('YYYY-MM-DD')}']`);
      if (!ele) return;
      ele.classList.add('c-fc-highlight');
    },
    removeOrgClass() {
      var cal = this.$refs[`cal${this.ym}`].$el;
      var eles = cal.getElementsByClassName('c-fc-highlight');
      if (!eles) return;
      for (var ele of eles) {
        ele.classList.remove('c-fc-highlight');
      }
    },
    // 祝日セルに .fc-holiday を付与（背景＝日曜と同じ、日付＝赤。アプリのカレンダーに合わせる）。
    // 静的JSON /js/statics/holidays/{country}/{lang}/{year}.json を国・言語・表示年で読み込む。
    markHolidays() {
      var r = this.$refs[`cal${this.ym}`];
      if (!r || !r.$el) return;
      var country = this.$store.state.user.country;
      var lang = this.$store.state.user.lang;
      if (!country || !lang) return;

      // 背景セル(.fc-day)と日付セル(.fc-day-top)のみ対象。月表示ではヘッダ th に data-date は付かない
      var cells = r.$el.querySelectorAll('.fc-day[data-date], .fc-day-top[data-date]');
      if (!cells.length) return;

      // 表示中セルに含まれる年を集計（月表示は前後月＝別年をまたぐことがある）
      var maps = {};
      var years = {};
      for (var i = 0; i < cells.length; i++) {
        var d = cells[i].getAttribute('data-date');
        if (!d || d.length < 4) continue;
        years[d.substring(0, 4)] = true;
      }
      var self = this;
      Object.keys(years).forEach(function(y) {
        var m = getCachedHolidays(country, lang, y);
        if (m === null) {
          // 未取得 → 取得後に再適用
          loadHolidays(country, lang, y).then(function() {
            self.markHolidays();
          });
        } else {
          maps[y] = m;
        }
      });

      // 取得済みの年について、該当日に .fc-holiday を付与/除去
      for (var j = 0; j < cells.length; j++) {
        var cell = cells[j];
        var date = cell.getAttribute('data-date'); // YYYY-MM-DD
        if (!date || date.length < 10) continue;
        var map = maps[date.substring(0, 4)];
        if (!map) continue; // その年はまだ未取得
        var ymd = date.substring(0, 4) + date.substring(5, 7) + date.substring(8, 10);
        if (map[ymd]) cell.classList.add('fc-holiday');
        else cell.classList.remove('fc-holiday');
      }
    },
    toEvents(events) {
      if (!events || events.length == 0) return [];
      var ms = this.$moment(String(this.ym) + '01', 'YYYYMMDD');
      var ps = {
        utcOffset: this.$moment().utcOffset(),
        curMonth: ms.format('YYYY-MM-DD HH:mm:ss'),
        nextMonth: ms.add(1, 'M').format('YYYY-MM-DD HH:mm:ss'),
        usePop: this.ua && this.ua.os && this.ua.os.name && ['Windows', 'Mac OS'].indexOf(this.ua.os.name) != -1,
      };
      var arr = [];
      for (var event of events) this.addCalenderEvents(arr, event, ps);
      return arr;
    },
    addToArray(arr, event, start, end, ps, uid) {
      var calEnd = event.all_day ? this.$moment.unix(end.unix() + 60 * 60 * 24) : end;
      arr.push({
        title: cnvl(event.title, `(${$T('page.cal.notitle')})`),
        desc: cnvl(event.desc, `(${$T('page.cal.nodesc')})`),
        location: event.location,
        start: this.dateFormatForCalendarStart(event, start),
        end: this.dateFormatForCalendarEnd(event, calEnd),
        startD: this.dateFormat(event, start),
        endD: this.dateFormat(event, end),
        allDay: event.all_day,
        pop: ps.usePop,
        item: event,
        uid: uid,
        outOfMonth: end.isBefore(ps.curMonth) || start.isSameOrAfter(ps.nextMonth),
      });
    },
    dateFormat(event, m) {
      return event.all_day ? m.format('YYYY-MM-DD') : m.format('YYYY-MM-DD HH:mm');
    },
    dateFormatForCalendarStart(event, m) {
      return event.all_day ? m.format('YYYY-MM-DD 00:00:00') : m.format('YYYY-MM-DD HH:mm');
    },
    dateFormatForCalendarEnd(event, m) {
      if (event.all_day) return m.format('YYYY-MM-DD 00:00:00');
      return Number(m.format('HHmm'))
        ? this.$moment(m)
            .add(1, 'd')
            .format('YYYY-MM-DD')
        : m.format('YYYY-MM-DD');
    },
    addCalenderEvents(arr, event, ps) {
      if (!event.repeat || !event.repeat.type || event.repeat.type == 'none') return this.addBasicEvent(arr, event, ps);
      var repeat = event.repeat;
      var t = repeat.type;
      if (t == 'dates') return this.addDatesEvent(arr, event, ps, repeat);
      if (t == 'week') return this.addWeekEvent(arr, event, ps, repeat);
      if (t == 'month') return this.addMonthEvent(arr, event, ps, repeat);
      if (t == 'year') return this.addYearEvent(arr, event, ps, repeat);
      console.error(`unknown event type ${t}. skip cleate event.`);
    },
    addBasicEvent(arr, event, ps) {
      if (event.all_day) {
        var s = this.$moment(event.d.s, 'YYYYMMDD');
        var e = this.$moment(event.d.e, 'YYYYMMDD');
        return this.addToArray(arr, event, s, e, ps, null);
      }
      var s = this.toMoment(event.start);
      var e = this.toMoment(event.end);
      return this.addToArray(arr, event, s, e, ps, null);
    },
    addDatesEvent(arr, event, ps, repeat) {
      var fromTo = this.toFromTo(event, ps, repeat);
      var from = 'd' + fromTo[0].format('YYYYMMDD');
      var to = 'd' + fromTo[1].format('YYYYMMDD');

      for (var d in event.dates) {
        if (d < from || to < d) continue;
        if (event.dates[d] != 1) {
          console.debug(`id=${event.id} d=${d} is deleted.`);
          continue;
        }
        if (event.all_day) {
          var s = this.$moment(d.substring(1), 'YYYYMMDD');
          var e = this.$moment(s).add(repeat.duration, 'days');
          this.addToArray(arr, event, s, e, ps, d);
          continue;
        }
        var startMin = repeat.startUtcMin + ps.utcOffset;
        var s = this.$moment(d.substring(1), 'YYYYMMDD').add(startMin, 'm');
        var e = this.$moment(s).add(repeat.duration, 'm');
        this.addToArray(arr, event, s, e, ps, d);
      }
    },
    addWeekEvent(arr, event, ps, repeat) {
      var fromTo = this.toRepeatFromTo(event, ps, repeat);
      var repeatFrom = fromTo[0];
      var repeatTo = fromTo[1];
      var from = fromTo[2];
      var to = fromTo[3];

      // to midnight time
      var current = this.$moment(from.format('YYYYMMDD') + '000000', 'YYYYMMDDHHmmss');
      var warr = [0, 0, 0, 0, 0, 0, 0];
      for (var w of repeat.weeks) {
        warr[Number(w.substring(1))] = 1;
      }

      var checkUnit = event.all_day ? 'date' : 'minute';
      while (current.isSameOrBefore(to, checkUnit)) {
        if (warr[current.weekday()]) {
          var d = 'd' + current.format('YYYYMMDD');
          if (event.dates && event.dates[d] == 9) {
            current.add(1, 'days');
            continue;
          }

          if (event.all_day) {
            var s = this.$moment(current);
            var e = this.$moment(s).add(repeat.duration, 'days');
            if (this.checkRange(event, s, repeatFrom, repeatTo)) this.addToArray(arr, event, s, e, ps, d);
          } else {
            var startMin = repeat.startUtcMin + ps.utcOffset;
            var s = this.$moment(current).add(startMin, 'm');
            var e = this.$moment(s).add(repeat.duration, 'm');
            if (this.checkRange(event, s, repeatFrom, repeatTo)) this.addToArray(arr, event, s, e, ps, d);
          }
        }
        current.add(1, 'days');
      }
    },
    addMonthEvent(arr, event, ps, repeat) {
      this.addEvents(arr, event, ps, repeat, 'M');
    },
    addYearEvent(arr, event, ps, repeat) {
      this.addEvents(arr, event, ps, repeat, 'Y');
    },
    addEvents(arr, event, ps, repeat, unit) {
      var fromTo = this.toRepeatFromTo(event, ps, repeat);
      var repeatFrom = fromTo[0];
      var repeatTo = fromTo[1];
      var from = fromTo[2];
      var to = fromTo[3];

      from.add(-1, unit);
      to.add(1, unit);

      // to midnight time
      var current = this.$moment(from.format('YYYYMM') + '01000000', 'YYYYMMDDHHmmss');

      while (current.isBefore(to)) {
        var startMin = event.all_day ? 0 : repeat.startAbsoluteMin;
        var tgtDate;
        if ('Y' == unit) {
          tgtDate = this.$moment(current.format('YYYY') + repeat.md.substring(1) + '000000', 'YYYYMMDDHHmmss');
        } else if ('M' == unit) {
          tgtDate = this.$moment(current.format('YYYYMM') + repeat.d.substring(1) + '000000', 'YYYYMMDDHHmmss');
        }
        if (!event.all_day) tgtDate.add(repeat.startAbsoluteMin, 'm');
        var d = 'd' + tgtDate.format('YYYYMMDD');
        if (event.dates && event.dates[d] == 9) {
          current.add(1, unit);
          continue;
        }
        if (event.all_day) {
          var s = this.$moment(tgtDate);
          var e = this.$moment(s).add(repeat.duration, 'days');
          if (this.checkRange(event, s, repeatFrom, repeatTo)) this.addToArray(arr, event, s, e, ps, d);
        } else {
          var s = this.$moment(tgtDate).add(ps.utcOffset, 'm');
          var e = this.$moment(s).add(repeat.duration, 'm');
          if (this.checkRange(event, s, repeatFrom, repeatTo)) this.addToArray(arr, event, s, e, ps, d);
        }
        current.add(1, unit);
      }
    },
    toRepeatFromTo(event, ps, repeat) {
      var fromTo = this.toFromTo(event, ps, repeat);
      var from = fromTo[0];
      var to = fromTo[1];
      var repeatFrom = this.$moment.unix(repeat.start);
      if (from.isBefore(repeatFrom)) {
        from = this.$moment(repeatFrom)
          .add(-1, 'days')
          .add(-repeat.duration, event.all_day ? 'day' : 'm');
      }
      var repeatTo = this.$moment.unix(repeat.end);
      if (repeatTo && to.isAfter(repeatTo)) {
        to = this.$moment(repeatTo).add(1, 'days');
      }
      return [repeatFrom, repeatTo, from, to];
    },
    toFromTo(event, ps, repeat) {
      return [
        this.$moment(ps.curMonth)
          .add(-7, 'days')
          .add(-repeat.duration, event.all_day ? 'day' : 'm'),
        this.$moment(ps.nextMonth).add(14, 'days'),
      ];
    },
    checkRange(event, s, rs, re) {
      if (event.all_day) {
        return s.isSameOrAfter(rs, 'date') && s.isSameOrBefore(re, 'date');
      }
      return s.isSameOrAfter(rs, 'minute') && s.isSameOrBefore(re, 'minute');
    },
    resetVal() {
      this.detailDialog = false;
      this.selectedEvent = null;
    },
    showEventDetail(event) {
      this.selectedEvent = event;
      this.detailDialog = true;
    },
    deleteEventSuccess() {
      this.detailDialog = false;
    },
    toMoment(v) {
      if (Number.isInteger(v)) return this.$moment.unix(v);
      if (typeof v === 'string' || v instanceof String) this.$moment(v, 'YYYY-MM-DD HH:mm:ss');
      // recreate
      return this.$moment(String(v), 'YYYY-MM-DD HH:mm:ss');
    },
  },
};
</script>

<style scoped>
.container {
  padding: 0;
  margin: 0;
  min-height: calc(100vh - 220px);
  min-width: 320px;
  width: 100%;
}
.c-m-c {
  min-height: calc(100vh - 220px);
  position: relative;
}
.le-tbs .c-m-c {
  min-height: calc(100vh - 156px);
}
.c-m-c .msg {
  position: absolute;
  top: calc(50% - 40px);
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 20px;
  color: rgba(0, 0, 0, 0.54);
}
.c-cal-header {
  height: 30px;
  background-color: red;
  position: sticky;
  top: 150px;
}
#calendar-content {
  height: 100%;
  width: 100%;
  background-color: white;
}
.event-list {
  padding: 0 1px 0 1px;
}
</style>
